import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { useOrder } from '../lib/orderContext';
import { trackAddToCartAndRedirect } from '../lib/metaPixel';
export function GuaranteeAndFinalCTA() {
  const {
    total,
    formattedTotal,
    checkoutUrl
  } = useOrder();
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const goToCheckout = () => {
    trackAddToCartAndRedirect(checkoutUrl, {
      content_name: 'El Protocolo Meno-Metabólico + 3 Bonos',
      content_ids: ['42499535011925'],
      content_type: 'product',
      value: total,
      currency: 'USD'
    });
  };
  return <section className="py-12 md:py-16 bg-[#2d4a3e]" data-id="element-89">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-91">
          <ShieldCheckIcon className="w-16 h-16 text-[#c9a961] mx-auto mb-6" data-id="element-92" />

          <h2 className="font-serif text-3xl md:text-4xl text-white mb-6 leading-tight" data-id="element-93">
            Garantía de satisfacción total — 7 días sin riesgo
          </h2>

          <p className="text-lg text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-94">
            Si en 7 días sientes que esto no era para ti, te devolvemos tu
            dinero. Sin preguntas. Sin complicaciones. Entra con confianza.
          </p>

          <motion.button onClick={goToCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto bg-[#c9a961] text-[#1f3a2e] px-10 py-5 rounded-lg text-xl font-bold shadow-xl hover:bg-[#b8954d] transition-colors mb-4" data-id="element-95">
            Comenzar Ahora Por {formattedTotal}
          </motion.button>

          <p className="text-sm text-[#a8a8a8]" data-id="element-96">
            🔒 Pago 100% seguro — Acceso inmediato después de tu compra
          </p>
        </motion.div>
      </div>
    </section>;
}